"use strict";
exports.__esModule = true;
exports.LaPosteEn4SliceType = void 0;
var LaPosteEn4SliceType;
(function (LaPosteEn4SliceType) {
    LaPosteEn4SliceType["ProofCategory"] = "la-poste-en-4_proof-category";
    LaPosteEn4SliceType["Disclaimer"] = "la-poste-en-4_disclaimer";
    LaPosteEn4SliceType["Footnotes"] = "la-poste-en-4_footnotes";
    LaPosteEn4SliceType["Header"] = "la-poste-en-4_header";
})(LaPosteEn4SliceType = exports.LaPosteEn4SliceType || (exports.LaPosteEn4SliceType = {}));
//# sourceMappingURL=la-poste-en-4.js.map